import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faBuilding, faInfoCircle, faEnvelope, faBars, faTimes, faUser, faSignInAlt, faSignOutAlt, faUserCircle, faCog, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import Translation from '../common/Translation';
import LanguageSelector from '../common/LanguageSelector';
import '../../styles/header.css';
import '../../styles/language-selector.css';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsNavOpen(false);
    setIsDropdownOpen(false);
  };
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          Real<span>Estate</span>
        </Link>

        <button className="nav-toggle" onClick={toggleNav}>
          <FontAwesomeIcon icon={isNavOpen ? faTimes : faBars} />
        </button>

        <nav className={`nav-menu ${isNavOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link to="/" onClick={() => setIsNavOpen(false)}>
                <FontAwesomeIcon icon={faHome} /> <Translation textKey="home" />
              </Link>
            </li>
            <li>
              <Link to="/properties" onClick={() => setIsNavOpen(false)}>
                <FontAwesomeIcon icon={faBuilding} /> <Translation textKey="properties" />
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={() => setIsNavOpen(false)}>
                <FontAwesomeIcon icon={faInfoCircle} /> <Translation textKey="about" />
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => setIsNavOpen(false)}>
                <FontAwesomeIcon icon={faEnvelope} /> <Translation textKey="contact" />
              </Link>
            </li>
          </ul>

          <div className="nav-auth">
            <LanguageSelector />
            
            {user ? (
              <div className="user-info" ref={dropdownRef}>
                <button onClick={toggleDropdown} className="user-dropdown-toggle">
                  <span className="user-name">
                    <FontAwesomeIcon icon={faUserCircle} /> {user.name || user.fullName}
                  </span>
                  <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}></span>
                </button>
                {isDropdownOpen && (
                  <div className="user-dropdown-menu">
                    <Link to="/profile" onClick={() => { setIsDropdownOpen(false); setIsNavOpen(false); }} className="dropdown-item">
                      <FontAwesomeIcon icon={faUser} /> <Translation textKey="myProfile" />
                    </Link>
                    <Link to="/profile?tab=properties" onClick={() => { setIsDropdownOpen(false); setIsNavOpen(false); }} className="dropdown-item">
                      <FontAwesomeIcon icon={faBuilding} /> <Translation textKey="viewedProperties" />
                    </Link>
                    <Link to="/profile?tab=requests" onClick={() => { setIsDropdownOpen(false); setIsNavOpen(false); }} className="dropdown-item">
                      <FontAwesomeIcon icon={faClipboardList} /> <Translation textKey="myRequests" />
                    </Link>
                    <Link to="/profile?tab=settings" onClick={() => { setIsDropdownOpen(false); setIsNavOpen(false); }} className="dropdown-item">
                      <FontAwesomeIcon icon={faCog} /> <Translation textKey="settings" />
                    </Link>
                    <div className="dropdown-divider"></div>
                    <button onClick={handleLogout} className="dropdown-item logout-item">
                      <FontAwesomeIcon icon={faSignOutAlt} /> <Translation textKey="logout" />
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="auth-buttons">
                <Link to="/login" onClick={() => setIsNavOpen(false)} className="auth-button login-button">
                  <FontAwesomeIcon icon={faSignInAlt} /> <Translation textKey="login" />
                </Link>
                <Link to="/signup" onClick={() => setIsNavOpen(false)} className="auth-button signup-button">
                  <FontAwesomeIcon icon={faUser} /> <Translation textKey="signup" />
                </Link>
              </div>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
